<template>
  <div v-reportView:load="{ pageload: 2, pagetype: 3 }" class="error">
    <span
      v-if="is404 == 404">Sorry,找不到页面了！！</span>
    <span v-else>Sorry,网站开了点小差！！</span>
  </div>
</template>

<script>
export default {
  name: 'Index',

  computed: {
    is404 () {
      return this.$router.history.current.params.id
    }
  },
}
</script>

<style scoped lang="scss">
  .error { height: 600px; padding-top: 100px; font-size: 20px; text-align: center; }
</style>
